import Image from 'next/image';

interface FallBackImageProps {
	width?: number;
	height?: number;
	style?: {
		[key: string]: string;
	};
	className?: string;
	alt?: string;
}

export default function FallBackImage({
	width = 300,
	height = 300,
	style = { width: '100%', height: '100%', objectFit: 'contain' },
	className,
	alt = 'Fallback logo',
}: FallBackImageProps) {
	return (
		<Image

			style={style}
			src={'/assets/logo.webp'}
			alt={alt}
			width={width}
			height={height}
			className={className ?? 'oneLax-logo'}
		/>
	);
}
